module.exports = __webpack_public_path__ + "static/mar.portrait-5013894598fae9b647b01be26856b3c6.jpg";